import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="w-full max-w-3xl mx-auto px-6 py-16" data-id="element-90">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="space-y-8 text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-91">
        <h3 className="text-3xl font-serif font-bold text-navy mb-8" data-id="element-92">
          Esto suena familiar:
        </h3>

        <p data-id="element-93">Planeas. Te quita horas.</p>

        <p data-id="element-94">
          Y aun así, hay días donde la clase se siente…{' '}
          <span className="italic text-navy font-semibold" data-id="element-95">floja</span>.
        </p>

        <p data-id="element-96">
          No porque no sepas. Sino porque no alcanzó el tiempo para convertir el
          tema en una actividad que realmente practique, una evidencia clara y
          un cierre que amarre.
        </p>

        <div className="bg-white p-6 md:p-8 rounded-lg shadow-sm border-l-4 border-amber my-8" data-id="element-97">
          <p className="mb-4" data-id="element-98">
            Entonces haces lo que todos hacemos para sobrevivir: explicas más de
            la cuenta, dejas tarea, y te llevas el peso a casa.
          </p>
          <p data-id="element-99">
            Lo peor no es el cansancio físico. Es esa parte mental que te dice:
          </p>
          <p className="text-2xl font-serif font-bold text-navy mt-4" data-id="element-100">
            “¿Esto sí fue una buena clase… o solo hablé?”
          </p>
        </div>
      </motion.div>
    </section>;
}